<cs-widgets
    [lobbyType]="lobbyType"
    [data]=""
    [isDefaultComposition]="isDefaultComposition"
    [currentProduct]="currentProduct"
    [categoryRoute]="categoryRoute"></cs-widgets>
